import url from 'url';
import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';
import { isInApp } from '@/utils/Mobile';
import { Storage } from '@/utils/Storage';
const hmac = (data, key) => {
    // eslint-disable-next-line
    let hmac = CryptoJS.HmacSHA256(data, key);

    return hmac.toString(CryptoJS.enc.Base64);
};

const defaultSchemaConfig = {
        access_key: '',
        secret_key: '',
        timestamp: ''
    },
    hmacSchemePlain = {
        buildCanonicalRequest(request, signedHeaders, schemeConfig, date) {
            const method = request.method.toUpperCase(),
                urlParts = url.parse(request.url),
                normalizedHeaders = Object.keys(request.headers).reduce((acc, header) => {
                    acc[header] = request.headers[header];
                    return acc;
                }, {}),
                headers = {};

            headers['Referer'] = `${window.location.origin}/`;

            signedHeaders.forEach((header) => {
                if (normalizedHeaders[header]) {
                    headers[header] = normalizedHeaders[header];
                }
            });

            const canonicalHeaders = Object.keys(headers).reduce((acc, header) => {
                    acc += `${header}:${headers[header].trim()}\n`;
                    return acc;
                }, ''),
                path = urlParts.pathname,
                query = request.params;
            let queryArray = [];

            for (let key in query) {
                if ((Array.isArray(query[key]) && query[key].length === 0) || query[key] === undefined || String(query[key]) === 'null') {
                    continue;
                }

                let queryKeyValue = encodeURIComponent(key) + '=' + encodeURIComponent(query[key] === 0 ? 0 : query[key] ? query[key] : '');

                queryArray.push(queryKeyValue);
            }

            queryArray.sort();

            return `${method}\n${path}\n${queryArray.join('&')}\n${schemeConfig.access_key}\n${date}\n${canonicalHeaders}`;
        },

        sign(request, signedHeaders) {
            const map = Cookies.get('X-TOKEN') ? JSON.parse(Cookies.get('X-TOKEN')) : {};
            let schemeConfig = map[window.location.host] || defaultSchemaConfig;

            if (Object.keys(schemeConfig).length !== 3) {
                schemeConfig = defaultSchemaConfig;
            }

            const date = new Date().toGMTString(),
                canonicalRequest = this.buildCanonicalRequest(request, signedHeaders, schemeConfig, date),
                signature = hmac(canonicalRequest, schemeConfig.secret_key);
            // if (isInApp()) {
            let Authorization =
                Storage.get('Authorization') || (window.location.pathname.includes('web') ? Storage.get('grtPcToken') : Storage.get('grtToken'));
            let userAgent = Storage.get('userAgent');
            if (Authorization) {
                request.headers['Authorization'] = Authorization;
                request.headers['TenantId'] = Storage.get('tenantId');
            }
            if (userAgent) {
                request.headers['Grt-Agent'] = userAgent;
            }
            // }

            if (!request.headers['Content-Type']) {
                request.headers['Content-Type'] = 'application/json';
            }

            request.headers['X-HMAC-DATE'] = date;
            request.headers['X-HMAC-ACCESS-KEY'] = schemeConfig.access_key;
            request.headers['X-HMAC-SIGNATURE'] = signature;
            request.headers['X-HMAC-ALGORITHM'] = 'hmac-sha256';
            request.headers['X-HMAC-TIMESTAMP'] = schemeConfig.timestamp;
            request.headers['X-HMAC-SIGNED-HEADERS'] = signedHeaders.join(';');
            return request;
        }
    };

export default hmacSchemePlain;
